import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgSelect = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		d: "M15.4218 20.6093C15.069 20.7754 14.7162 20.7944 14.3633 20.6664C14.0105 20.5384 13.7497 20.3005 13.581 19.9526L10.8197 14.1104L8.67976 17.0542C8.41898 17.4165 8.07382 17.5297 7.64429 17.3938C7.21476 17.258 7 16.9711 7 16.5333V4.91668C7 4.53928 7.17273 4.26754 7.5182 4.10148C7.86366 3.93542 8.18949 3.97316 8.49568 4.2147L17.7919 11.4157C18.1447 11.6723 18.2484 12.0044 18.103 12.412C17.9576 12.8196 17.6621 13.0234 17.2166 13.0234H13.3509L16.0891 18.7978C16.2579 19.145 16.2772 19.4922 16.1471 19.8394C16.017 20.1866 15.7753 20.4433 15.4218 20.6093Z",
		fill: "currentColor"
	})
});
export default SvgSelect;
